// vibe-slideshow.js
document.addEventListener('DOMContentLoaded', () => {
  let currentVibe = 0;
  const vibeFrames = document.querySelectorAll('.vibe-frame');
  const vibeNormal = window.vibeSettings.normalInterval || 5000; 
  const vibeTemp = window.vibeSettings.tempInterval || 10000; 
  let vibeTimer = setInterval(() => shiftVibe(1), vibeNormal);

  function showVibe(index) {
    if (index >= vibeFrames.length) index = 0;
    if (index < 0) index = vibeFrames.length - 1;

    vibeFrames.forEach((frame, i) => {
      frame.classList.remove('vibe-active', 'vibe-exit');
      frame.style.animation = '';
      if (i === currentVibe) {
        frame.classList.add('vibe-exit');
      }
    });

    vibeFrames[index].classList.add('vibe-active');

    currentVibe = index;
  }

  function shiftVibe(direction) {
    clearInterval(vibeTimer);
    showVibe(currentVibe + direction);
    vibeTimer = setInterval(() => shiftVibe(1), vibeTemp);
    setTimeout(() => {
      clearInterval(vibeTimer);
      vibeTimer = setInterval(() => shiftVibe(1), vibeNormal);
    }, vibeTemp);
  }

  // Attach event listeners to buttons
  const prevButton = document.querySelector('.vibe-prev');
  const nextButton = document.querySelector('.vibe-next');
  if (prevButton) prevButton.addEventListener('click', () => shiftVibe(-1));
  if (nextButton) nextButton.addEventListener('click', () => shiftVibe(1));
});